import AbstractRsvpDetailsPageController from './abstract-details-controller';

export default class RsvpDetailsMessagesPageController extends AbstractRsvpDetailsPageController {

}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/rsvps/details/messages-controller.js